<template>
<div>
    <div v-if="hierarchy">
        <h1>
            {{hierarchy.type}}: {{hierarchy.name}}
        </h1>
        <div v-if="hierarchy.organization" style="padding-bottom:20px;">
            Billing Organization: {{hierarchy.organization.name}}
        </div>
    </div>

    <timezone v-if="timezone_meta" :current_timezone="timezone_meta.nice_timezone"></timezone>
    <el-table
        :data="rows"
        style="width: 100%;margin-bottom:20px;">
        <el-table-column
            prop="indented_type"
            label="Level"
            width="120"
            sortable
        >
        </el-table-column>
        <el-table-column
            prop="name"
            label="Name"
            width="180"
            sortable
        >
            <template slot-scope="scope">
                <el-button type="text" @click="go(scope.row.id)">
                    {{scope.row.name}}
                </el-button>
            </template>
        </el-table-column>
        <el-table-column
            prop="crawled_count"
            label="Crawled"
            sortable
        >
        </el-table-column>
        <el-table-column
            prop="assets_count"
            label="Deduped"
            sortable
        >
            <template slot-scope="scope">
                <el-button type="text" @click="go(scope.row.id)">
                    {{scope.row.assets_count}}
                </el-button>
            </template>
        </el-table-column>
        <el-table-column
            prop="maps_count"
            label="Maps"
            sortable
        >
            <template slot-scope="scope">
                <a :href="'/extents/' + scope.row.id + '/maps'">{{scope.row.maps_count}}</a>
            </template>
        </el-table-column>
        <el-table-column
            prop="reports_count"
            label="Reports"
            sortable
        >
            <template slot-scope="scope">
                <a :href="'/extents/' + scope.row.id + '/reports'">{{scope.row.reports_count}}</a>
            </template>
        </el-table-column>
        <el-table-column
            prop="charts_count"
            label="Charts"
            sortable
        >
        </el-table-column>
        <el-table-column
            prop="annotations_count"
            label="Annotations"
            sortable
        >
            <template slot-scope="scope">
                <a :href="'/annotations/list/' + scope.row.id ">{{scope.row.annotations_count}}</a>
            </template>
        </el-table-column>
        <el-table-column
            prop="flattened_count"
            label="Tables"
            sortable
        >
            <template slot-scope="scope">
                <a :href="'/tables/' + scope.row.id">{{scope.row.flattened_count}}</a>
            </template>
        </el-table-column>
        <el-table-column
            prop="last_job_chain.date_in_local"
            label="Last Job"
            width="120"
            sortable
        >
            <template slot-scope="scope">
                <a :href="'/progress/' + scope.row.last_job_chain.id">
                    <div>{{scope.row.last_job_chain.date_in_local}}</div>
                </a>
            </template>
        </el-table-column>
    </el-table>
</div>
</template>

<script>
export default {
    name: "ExtentDetails",
    props: ['extent_id_from_blade'],
    mounted() {
        this.get_extent()
    },
    data() {
        return {
            rows: [],
            hierarchy: [],
            timezone_meta: null,
        }
    },
    methods: {
        go(id) {
            axios.post('/extents/current', {
                current_extent: id
            }).then(response => {
                window.open('/assets')
            })
                .catch(error => {
                    console.log('could not set the extent session variable')
                })
        },
        get_extent() {
            axios.get('/extents/' + this.extent_id_from_blade + '/get_details')
                .then(response => {
                    this.rows = response.data.rows
                    this.hierarchy = response.data.hierarchy
                    this.timezone_meta = response.data.meta
                })
                .catch(error => {
                    console.log('could not load map')
                })
        },
    },
}
</script>

<style scoped>

</style>